import { useState } from "react";
import styles from "../common.module.css";
import { useEnclaveApi } from "../../EnclaveSDK/context/EnclaveConnectProvider";
import { networkDetails } from "../../EnclaveSDK/EnclaveUtils/constants";
import { ArrowDown, SendHorizontal, UserX, Coins } from "lucide-react";
import { BoltSharp } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import isPWA from "../../../utils/pwaUtils";
import activityStyles from "./activity.module.css";
import TxnDetailsModal from "../../tnxDetailsModal/tnxDetailsModal";
import { formatPrice } from "../../../utils/priceUtils";
import dollarLogo from "../../../assets/dollar_jpeg 1.png";

const replaceUSDC = (str) => {
  if (!str) return "";
  return str.replace(/USDC|USD/g, "USD");
};

const groupTransactionsByDate = (transactions) => {
  const groups = {};

  transactions.forEach((txn) => {
    const date = new Date(txn.response.timestamp * 1000);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    let dateKey;
    if (date.toDateString() === today.toDateString()) {
      dateKey = "Today";
    } else if (date.toDateString() === yesterday.toDateString()) {
      dateKey = "Yesterday";
    } else {
      dateKey = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    }

    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(txn);
  });

  return groups;
};

const TransactionCard = (props) => {
  const { txn, walletAddress, allTokensList } = props;

  console.log("TX DET: ", { txn }, walletAddress);
  const [viewInternal, setViewInternal] = useState(false);
  const [showTxnDetailsModal, setShowTxnDetailsModal] = useState(false);

  const txnSet = txn.request.transactionDetails;
  const network = txn.request.network;
  const metaData = txn.request.metaData;
  const chainDetails = networkDetails[network];

  const closeTxnDetailsModal = () => {
    setShowTxnDetailsModal(false);
  };

  const spliceAddress = (address) => {
    return address ? address.slice(0, 8) + "..." + address.slice(-4) : "";
  };

  return (
    <div
      key={txn.response.txnHash}
      className={activityStyles.transactionCard}
      onClick={(e) => {
        e.stopPropagation();
        setShowTxnDetailsModal(true);
      }}
    >
      <div className={activityStyles.tokenLogoBox}>
        <>
          {!metaData ? (
            <div
              className={activityStyles.tokenLogo}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#2D2D2D",
              }}
            >
              <Coins size={24} />
            </div>
          ) : (
            <img
              className={activityStyles.tokenLogo}
              src={
                metaData.type === "TRANSFER" &&
                (metaData.tokenSymbol === "USD" ||
                  metaData.tokenSymbol === "USDC")
                  ? dollarLogo
                  : metaData.type === "TRANSFER"
                  ? allTokensList.find(
                      (token) => token.symbol === metaData.tokenSymbol
                    )?.logoURI
                  : metaData.type === "BUY"
                  ? allTokensList.find(
                      (token) => token.symbol === metaData.destinationToken
                    )?.logoURI
                  : allTokensList.find(
                      (token) => token.symbol === metaData.sourceToken
                    )?.logoURI
              }
              alt={chainDetails.name}
            />
          )}
          {!metaData?.type ? null : (
            <div className={activityStyles.actionIcon}>
              {metaData.type === "TRANSFER" ? (
                <SendHorizontal size={15} color="white" />
              ) : (
                <ArrowDown size={18} color="white" />
              )}
            </div>
          )}
        </>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          width: "100%",
        }}
      >
        {!metaData ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "4px",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              <span style={{ fontSize: "1.1rem" }}>{txn.request.label}</span>
              <span style={{ fontSize: "0.9rem", color: "gray" }}>
                {chainDetails.name}
              </span>
            </div>
          </div>
        ) : metaData?.type === "BUY" || metaData?.type === "SELL" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "4px",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              <span style={{ fontSize: "1.1rem" }}>{metaData.label}</span>
              <span style={{ fontSize: "0.9rem", color: "gray" }}>
                {metaData.sourceNetwork || chainDetails.name}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                fontSize: "0.9rem",
              }}
            >
              <span style={{ color: "#4dd15b", textAlign: "right" }}>
                {"+"}
                {formatPrice(metaData.destinationAmount)}
                {" " + replaceUSDC(metaData.destinationToken)}
              </span>

              <span style={{ color: "gray", textAlign: "right" }}>
                {"-"}
                {formatPrice(metaData.sourceAmount)}
                {" " + replaceUSDC(metaData.sourceToken)}
              </span>
            </div>
          </div>
        ) : metaData?.type === "TRANSFER" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "4px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                justifyContent: "space-between",
              }}
            >
              <span style={{ fontSize: "1.1rem" }}>{txn.request.label}</span>
              <span style={{ fontSize: "0.9rem", color: "gray" }}>
                {chainDetails.name}
              </span>
            </div>
            <span
              style={{
                fontSize: "1rem",
                color: "white",
                textAlign: "right",
              }}
            >
              {`${formatPrice(metaData.tokenAmount || "0")} ${replaceUSDC(
                metaData.tokenSymbol
              )}`}
            </span>
          </div>
        ) : null}
      </div>

      <TxnDetailsModal
        isOpen={showTxnDetailsModal}
        closeTxnDetailsModal={closeTxnDetailsModal}
        txn={txn}
        onClick={(e) => e.stopPropagation()}
        allTokensList={allTokensList}
        chainDetails={chainDetails}
      />
    </div>
  );
};

export default function ActivityPage() {
  const { userData, activityLoading, transactions, allTokensList } =
    useEnclaveApi();

  return (
    <div
      className={`${styles.page} ${isPWA() ? styles.pageOverrides : ""}`}
      style={{
        maxWidth: "960px",
        margin: "auto",
        padding: "5px 14px 24px 14px",
      }}
    >
      {!userData || !userData.wallet?.scw_address ? (
        <div className={styles.disconnectedAccount}>
          <UserX size={32} />
          <p>Please connect your account to view details</p>
        </div>
      ) : (
        <>
          <h1>Activity</h1>
          {activityLoading ? (
            <div className={styles.loadingContainer}>
              <CircularProgress color="inherit" />
            </div>
          ) : transactions.length === 0 ? (
            <div className={styles.noBalances}>
              <BoltSharp style={{ fontSize: "38px" }} />
              <p style={{ marginTop: "10px", fontSize: "1rem" }}>
                Transaction details will appear once you start trading.
              </p>
              <br />
            </div>
          ) : (
            <div className={activityStyles.transactionContainer}>
              {Object.entries(groupTransactionsByDate(transactions)).map(
                ([date, txns]) => (
                  <div key={date}>
                    <h3
                      style={{
                        margin: "20px 0 12px 0",
                        fontSize: "0.9rem",
                        color: "gray",
                      }}
                    >
                      {date}
                    </h3>
                    {txns.map((txn, index) => (
                      <TransactionCard
                        key={index}
                        txn={txn}
                        walletAddress={userData?.wallet?.scw_address}
                        allTokensList={allTokensList}
                      />
                    ))}
                  </div>
                )
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

const spliceAddress = (address) => {
  return address.slice(0, 8) + "..." + address.slice(-4);
};
